import { WithSymbol, WithTemplate } from './layer.model';
import { ColorBookApiModel } from './color-book.model';
import { PlotStyleApiModel } from './plot-style.model';
import { LineweightApiModel } from './lineweight.model';

export type AutodeskLayerApiModel = {
  id: number;
  color: string;
  isPlot: boolean;
  isNewViewportFreeze: boolean;
  transparency: number;
  colorBook: { id: number } | null;
  plotStyle: { id: number } | null;
  layer: { id: number };
  lineweight: { id: number };
};

export type WithLayer = AutodeskLayerApiModel & { layer: WithTemplate & WithSymbol };

export type WithColorBook = AutodeskLayerApiModel & { colorBook: ColorBookApiModel };

export type WithPlotStyle = AutodeskLayerApiModel & { plotStyle: PlotStyleApiModel };

export type WithLineweight = AutodeskLayerApiModel & { lineweight: LineweightApiModel };

export enum AutodeskLayerRelationship {
  LAYER = 'LAYER',
  COLOR_BOOK = 'COLOR_BOOK',
  LINEWEIGHT = 'LINEWEIGHT',
  SYMBOL = 'SYMBOL',
  TEMPLATE = 'TEMPLATE',
  PLOT_STYLE = 'PLOT_STYLE',
}
